import React from "react";
import { Row, Col, Card } from "react-bootstrap"; // Import Bootstrap components
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import { motion } from "framer-motion";

const Benefits = () => {
  const benefitsList = [
    {
      title: "Governance & Control",
      description:
        "You can manage all LLM under single window with SSTAI Framework",
    },
    {
      title: "Cost Monitoring/Spend Control",
      description: "Prevents unnecessary expenses with real-time tracking.",
    },
    {
      title: "Usage Insights",
      description: "Tracks LLM usage across departments and projects.",
    },
    {
      title: "Single Interface for All LLMs",
      description:
        "Eliminates the complexity of managing multiple chat models.",
    },
    {
      title: "Security & Permissions",
      description: "Integrates with Active Directory for controlled access.",
    },
    {
      title: "Containerization for Scalability",
      description:
        "Deploys LLM APIs in a containerized format for seamless expansion.",
    },
    {
      title: "Automated Alerts",
      description:
        "Automatically notifies users when predefined limits are reached, ensuring timely actions.",
    },
    {
      title: "Automated Invoices",
      description:
        "Generates invoices automatically for specified periods, streamlining billing processes.",
    },
    {
      title: "Customized Chargeback",
      description:
        "We can set chargeback to the project or department in organization.",
    },
  ];
  return (
    <div className="w-100 px-1">
      <h3 className="card-title" style={{ padding: "10px" }}>
        Benefits of LLMInsight.ai
      </h3>
      <Row
        xs={1}
        sm={2}
        md={3}
        lg={4}
        xl={4}
        className="justify-content-center g-3 mx-auto"
        style={{
          maxWidth: window.innerWidth >= 1600 ? "1600px" : "100%",
          marginBottom: 20,
        }}
      >
        {benefitsList.map((card, index) => (
          <Col key={index} className="d-flex">
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="w-100" // Ensures uniform width
            >
              <Card
                className="h-100 border border-secondary border-opacity-25 rounded-2 shadow-sm"
                style={{
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  transition: "box-shadow 0.3s",
                }}
              >
                <Card.Body className="p-3 d-flex flex-column">
                  <Card.Title
                    as="h6"
                    className="mb-1"
                    style={{
                      fontSize: "clamp(14px, 1.25vw, 18px)", // Responsive font size
                      lineHeight: "clamp(18px, 1.2vw, 24px)", // Reduced line height for better spacing
                      color: "#073D8D",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      marginBottom: "4px", // Reduces space between title and description
                    }}
                  >
                    {card.title}
                  </Card.Title>
                  <Card.Text
                    className="text-muted"
                    style={{
                      fontSize: "clamp(10px, 0.9vw, 14px)", // Responsive font size
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      color: "#333",
                    }}
                  >
                    {card.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Benefits;
